export default "/_next/static/images/caregiver1-3aa50ad54d13fd3f4138e53655b8e560.png";